

<div class="cf"></div>
<div class="table-responsive table-fixed table-v-scroll margin0" style="width: 100%">
  <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
    <thead>
      <tr>
        <th style="width:150px;" class="min-width-td">Property Name</th>
        <th class="whitespacenowrap">Staus</th>
        <th class="whitespacenowrap">Asking Price</th>
        <th class="whitespacenowrap">Brokerage</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of propertyList;let i = index">
        <td>
          <p>
            <a *ngIf="item.Type == 1" href="javascript:void(0);" routerLink="/viewdeproperty/{{item.Guid}}" [queryParams]="{'prevroute':'Property List',link:'property-listing'}">{{ item.PropertyName }}</a>
            <a *ngIf="item.Type == 2" href="javascript:void(0);" routerLink="/viewproperty/{{item.Guid}}" [queryParams]="{'prevroute':'Property List',link:'property-listing'}">{{ item.PropertyName }}</a>
          </p>
        </td>
        <td><p [ngClass]="{'redtextlabel':(item.PropertyStatus === 'Closed' || item.PropertyStatus === 'Sold'),'greentextlabel':item.PropertyStatus === 'Available','orangetextlabel':item.PropertyStatus === 'Under Contract','not-available':item.PropertyStatus === 'Not Available','Off-Market':item.PropertyStatus === 'Off-Market', 'darkbluetextlabel':item.PropertyStatus === 'Pending Approval'}">{{ item.PropertyStatus }}</p></td>
        <td>
          <p class="whitespacenowrap" *ngIf="item.Unpriced">Unpriced</p>
          <p class="whitespacenowrap" *ngIf="!item.Unpriced">{{(item.Price) ? '$ '+ (item.Price | number:0) : '-'}}</p>
        </td>
        <td ><p>{{ item.BrokerageName ? item.BrokerageName : '-' }}</p></td>
      </tr>

    </tbody>
    <tfoot>
      <tr *ngIf="propertyList?.length == 0">
        <td colspan="4" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>

</div>




